import { HIDE_TOOLTIP } from '../../../reducer';

export const SHOW_TOOLTIP = 'ReferredPartnersShow/SHOW_TOOLTIP';
export const LOAD_DIRECT_MERCHANT = 'LOAD_DIRECT_MERCHANT';
export const SET_DIRECT_MERCHANT = 'SET_DIRECT_MERCHANT';
export const DOWNLOAD_CSV = 'Merchants/DOWNLOAD_CSV';
export const RESET_DIRECT_MERCHANT_SHOW = 'RESET_DIRECT_MERCHANT_SHOW';

export const loadDirectMerchant = id => ({
  type: LOAD_DIRECT_MERCHANT,
  id
});

export const setDirectMerchant = merchant => ({
  type: SET_DIRECT_MERCHANT,
  merchant
});

export const downloadCsv = () => ({
  type: DOWNLOAD_CSV
});

export const resetDirectMerchantShow = () => ({
  type: RESET_DIRECT_MERCHANT_SHOW
});

export const showTooltip = activeTooltip => ({
  type: SHOW_TOOLTIP,
  activeTooltip
});

export const initialState = {
  directMerchant: null,
  loading: true,
  activeTooltip: ''
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_DIRECT_MERCHANT:
      return {
        ...state,
        directMerchant: action.merchant,
        loading: false
      };
    case RESET_DIRECT_MERCHANT_SHOW:
      return {
        ...state,
        ...initialState
      };
    case SHOW_TOOLTIP:
      return {
        ...state,
        activeTooltip: action.activeTooltip
      };
    case HIDE_TOOLTIP:
      return {
        ...state,
        activeTooltip: ''
      };
    default:
      return state;
  }
};
